import { type CellContext, type Row as RowType } from '@tanstack/react-table';
import React from 'react';
import { mergeClassNames } from '../../../../../utils/cssClassNameHelper';
import { Box } from '../../../../Box';
import { dataTableClassnames } from '../../const/classNames';
import { CellWrapper } from './cells/CellWrapper';

interface RowProps {
  row: RowType<object>;
  selected: boolean;
  expanded: boolean;
}

export const Row: React.FC<RowProps> = ({ row }) => {
  return (
    <Box
      className={mergeClassNames(
        `${dataTableClassnames.table.row.root} ${dataTableClassnames.table.row.body} ${dataTableClassnames.table.row.depth(row.depth)}`,
        {
          [dataTableClassnames.table.row.state.selected]: row.getIsSelected()
        }
      )}
      role="row"
    >
      {row.getVisibleCells().map((cell) => {
        const style = (cell.column.columnDef.meta as any)?.getCellWrapperStyle
          ? (cell.column.columnDef.meta as any).getCellWrapperStyle(row.original)
          : undefined;

        return (
          <CellWrapper
            key={cell.id}
            className={dataTableClassnames.table.cell.field(cell.column.id)}
            fieldName={cell.column.id}
            style={style}
            width={cell.column.getSize()}
          >
            {typeof cell.column.columnDef.cell === 'string'
              ? cell.column.columnDef.cell
              : cell.column.columnDef.cell?.({ row } as CellContext<object, unknown>)}
          </CellWrapper>
        );
      })}
    </Box>
  );
};
